import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { format } from 'date-fns'

import { useGetListItemInsights } from '../../features/hooks/useGetListItemInsights'

import { getCampaigns, clearCampaigns } from '../../modules/actions/campaigns'
import { campaignsDateRangeSelector } from '../../modules/selectors/campaigns'

import { DATES_FORMAT_BE } from '../../constants/dates'

const useCampaignFetchData = ({ adAccountId, platform, withPagination }) => {
  const dispatch = useDispatch()

  const campaignsDateRange = useSelector(campaignsDateRangeSelector)
  const { date_preset, startDate, endDate } = campaignsDateRange

  const insights = useGetListItemInsights(platform)

  return useCallback(
    (
      campaignsAfter,
      sessionId,
      loadOptions = {
        skipClearingCampaigns: false
      }
    ) => {
      // clear before fetching new campaigns
      !loadOptions.skipClearingCampaigns && dispatch(clearCampaigns())

      dispatch(
        getCampaigns(
          {
            date_from: startDate && format(startDate, DATES_FORMAT_BE),
            date_to: endDate && format(endDate, DATES_FORMAT_BE),
            date_preset,
            insights,
            account: adAccountId,
            // pagination logic
            ...(withPagination && { limit: 10 }),
            ...(campaignsAfter && { after: campaignsAfter }),
            ...(sessionId && { session_id: sessionId })
          },
          platform
        )
      )
    },
    [dispatch, platform, adAccountId, date_preset, startDate, endDate, withPagination, insights]
  )
}

export default useCampaignFetchData
